module.exports = __webpack_public_path__ + "img/image29.2ca83081.png";